module.exports = __webpack_public_path__ + "static/BuyNow_Paylater-841f5c88ec3469599e43c6e5637be4cc.mp4";